import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, usePageTitle } from "@/lib/api";

export default function ResetPassword() {
  usePageTitle("Reset Password");
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password });
      toast.success("Password updated. Please sign in.");
      nav("/login");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <section className="bg-pitch min-h-screen pt-40 pb-20" data-testid="reset-password-page">
      <form onSubmit={submit} className="wrap max-w-md card-navy p-8 space-y-5">
        <h1 className="h-display text-4xl">Reset Password</h1>
        <div><label className="label" htmlFor="reset-password">New Password</label><input id="reset-password" type="password" minLength={8} required className="field" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" /></div>
        <button className="btn-gold w-full" data-testid="reset-password-submit">Update Password</button>
      </form>
    </section>
  );
}
